enum NewBusinessApplicationSectionName {
	PROPERTY_ADDRESS = 'PropertyAddress',
	PERILS = 'Perils',
	APPETITE_AND_ELIGIBILITY = 'AppetiteAndEligibility',
	BUILDINGS = 'Buildings',
	BUILDING = 'Building',
	DWELLING = 'Dwelling',
	COVERAGE_LIMITS = 'CoverageLimits',
	INSURED = 'Insured',
	MORTGAGEES = 'Mortgagees',
	DISCLOSURES = 'Disclosures',
	INCEPTION_DATE = 'InceptionDate',
	PAY_AND_ISSUE_POLICY = 'PayAndIssuePolicy',
	UNKNOWN = 'Unknown',
}

namespace NewBusinessApplicationSectionName {
	export function toEnumList(): NewBusinessApplicationSectionName[] {
		let newBusinessApplicationSectionNames: NewBusinessApplicationSectionName[] = Object.keys(NewBusinessApplicationSectionName)
			.filter((key: string) => key !== NewBusinessApplicationSectionName.toEnumList.name)
			.map((key: string) => NewBusinessApplicationSectionName[key]);
		return newBusinessApplicationSectionNames;
	}
}

export default NewBusinessApplicationSectionName;